import img1 from "../assets/img/_1080571.webp";
import img2 from "../assets/img/_1033783.webp";
import img3 from "../assets/img/_1035852.webp";

function Home() {
  return <div className="main-wrapper">
    
    

    <h2 className="font-color">Herzlich willkommen in meiner Praxis für Körperpsychotherapie</h2>

    <p>
      in der Theresienstraße 148 in München. Hier finden Sie Unterstützung in Ihrer ganz persönlichen Lebenssituation. 
    </p>

    <p>
      <div className="bulletpoint"/>Sie fühlen sich erschöpft? Häufig müde und energielos?<br/>
      <div className="bulletpoint"/>Der Berg Arbeit wird immer größer?<br/>
      <div className="bulletpoint"/>Die Gedanken drehen sich im Kreis?<br/>
      <div className="bulletpoint"/>Keine Zeit für das, was eigentlich Spaß macht?<br/>
      <div className="bulletpoint"/>Beziehungsprobleme?<br/>
      <div className="bulletpoint"/>Trauer? Trennung? Scheidung?<br/>
      <div className="bulletpoint"/>Keiner der zuhört? Sie fühlen sich unverstanden?<br/>
    </p>

    <p>
      Als zertifizierte Tanz- und Bewegungstherapeutin und Heilpraktikerin für Psychotherapie biete ich fundierte Hilfe und Unterstützung an – bei einer Vielzahl psychischer und psychosomatischer Erkrankungen sowie bei beruflichen oder privaten Belastungen und in Lebenskrisen. 
    </p>

    <p>
      <div className="bulletpoint"/>Resilienz stärken<br/>
      <div className="bulletpoint"/>Stress bewältigen<br/>
      <div className="bulletpoint"/>Veränderungen meistern<br/>
      <div className="bulletpoint"/>Selbstsicherheit & Selbstwert steigern<br/>
      <div className="bulletpoint"/>Lebensfreude wieder spüren<br/>
      <div className="bulletpoint"/>Lebendigkeit & Kreativität entwickeln<br/>
    </p>

    <p>
      Tanz- und Bewegungstherapie ist eine körperorientierte Psychotherapie und kann oft dort helfen, wo es keine Worte gibt oder Sprache nicht ausreicht. Im Körper sind viele Eindrücke gespeichert, und Eindruck braucht Ausdruck, um wieder in Balance zu kommen. Bewegung hilft, einen ganz eigenen, individuellen Selbstausdruck zu finden, und auch die eigenen Gefühle fühlen zu können. Tanztherapie arbeitet häufig weniger mit den Erlebnissen als mit den körperlichen und emotionalen Reaktionen auf diese. Es ist eine sehr individuelle, kreative und prozessorientierte Methode.
    </p>

    <h3>Mein Angebot</h3>

    <p>
      <div className="bulletpoint"/>Holistische Tanz- und Bewegungstherapie (HTB)<br/>
      <div className="bulletpoint"/>Gesprächstherapie nach Carl Rogers<br/>
      <div className="bulletpoint"/>Stressbewältigung & Burnoutprophylaxe<br/>
      <div className="bulletpoint"/>Techniken zur Selbstregulation<br/>
      <div className="bulletpoint"/>Kreativer Tanz und Heilsame Bewegung<br/>
      <div className="bulletpoint"/>Continuum nach Emilie Conrad<br/>
    </p>

    
    <img className="right size53" src={img1}/>
    <img className="left size53" src={img2}/>
    <img className="right size53" src={img3}/>

  </div>;
}
export default Home;